// extracted by mini-css-extract-plugin
export default {"Map":"Map__3S--6","hasPreview":"hasPreview__0SIqV"};